<template>
    <div>
        <div class="form-group-style">
            <el-form class="form-container" :model="info" ref="ModelForm" :rules="modelRules">
                <div class="form-item bidding-tips">
                    <div class="form-label">
                        <span class="label">楼盘名称：</span>
                    </div>
                    <div class="form-label" style="text-align: left;"><span class="label">{{ info.house_name }}</span>
                    </div>
                    <div class="form-label">
                        <span class="label">站点:</span>
                    </div>
                    <div class="form-label" style="text-align: left;"><span class="label">{{ info.site_name }}</span>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">分类：</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item prop="name">
                            <el-select v-model="info.type_id" placeholder="请选择">
                                <el-option v-for="item in typeList" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">动态标题</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item prop="title">
                            <el-input placeholder="请输入模板名称" class="input-control" v-model="info.title"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">动态内容</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item editor" style="width:1000px">
                        <el-form-item prop="content">
                            <UE :options="eidtorOptions" @addhouse="showHouseAdd" defaultMsg="" ref="ue" />
                            <span v-if="contentWords" class="word_error">{{contentWords}}</span>

                        </el-form-item>
                    </div>
                </div>

                <div class="form-button">
                    <el-button type="primary" :loading="isloading" @click="submitForm('ModelForm', 1)">保存</el-button>
                    <el-button type="info" plain @click="toList()">取 消</el-button>
                </div>
            </el-form>
        </div>
        <el-dialog title="插入楼盘卡片" :visible.sync="centerDialogVisible" :before-close="hideDia" width="500px"
            custom-class="hosueDia" center>
            <div class="house-ipt">
                <span class="label">查询楼盘：</span>
                <AutoComplete ref="recommandRef" :callback="insertHouse" placeholder="请选择推荐楼盘" style="width: 100%;" />
            </div>
            <p class="error-tip" v-if='showError'>楼盘不能为空</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="hideDia">取 消</el-button>
                <el-button type="primary" @click="editorInsert">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
        title="违禁词提示"
        :visible.sync="wordsDialog"
        width="40%"
        :before-close="(done)=>{done()}">
        <div style="margin-bottom:10px;line-height: 20px;" v-if="findWords.type_common.length > 0">存在通用违禁词：<span style="color:red">{{findWords.type_common.join(',')}}</span></div>
        <div style="margin-bottom:10px;line-height: 20px;" v-if="findWords.type_risk.length > 0">存在风险违禁词：<span style="color:red">{{findWords.type_risk.join(',')}}</span></div>
        <div style="margin-bottom:10px;line-height: 20px;" v-if="findWords.type_high_risk.length > 0">存在高危违禁词：<span style="color:red">{{findWords.type_high_risk.join(',')}}</span></div>
        <div style="margin-bottom:10px;line-height: 20px;" v-if="findWords.type_author.length > 0">存在来源屏蔽词：<span style="color:red">{{findWords.type_author.join(',')}}</span></div>
        <div style="margin-bottom:10px;" v-if="findWords.type_risk.length > 0 && !findWords.type_high_risk.length > 0 && !findWords.type_common.length > 0 && !findWords.type_author.length > 0">风险违禁词在一定语义下可能会存在风险！</div>
        <div>请检查并修改后再进行保存！恶意填写违禁词，情节严重将进行账号冻结并追究责任。</div>
        <span slot="footer" class="dialog-footer">
            <template v-if="findWords.type_risk.length > 0 && !findWords.type_high_risk.length > 0 && !findWords.type_common.length > 0 && !findWords.type_author.length > 0">
                <el-button type="primary" @click="cancelSave">暂不保存</el-button>
                <el-button type="primary" @click="continueSave">继续保存</el-button>
            </template>
            <template v-else>
                <el-button type="primary" @click="cancelSave">确定</el-button>
            </template>
        </span>
    </el-dialog>  
    </div>
</template>
<script>
import { validateEmpty } from "@/utils/validate";
import { NEWS_MODEL } from "@/config/index";
import { UPLOAD_CODE } from "@/config/index";
import EditorBar from "@/components/newsModelEditor/modelEditor";
import UE from '@/components/editoritem/uEditor';
import { getHouseTrendsDetail, editHouseTrends } from '@/service/dynamicModel'
import AutoComplete from "@/components/autoComplete";
import {getFilterWords} from '@/service/customer'


export default {
    name: "edit",
    components: {
        EditorBar,
        UE,
        AutoComplete
    },
    computed:{
        contentWords(){
            let words = []
            if(this.arisenWords && this.arisenWords.length>0){
                this.arisenWords.forEach((item)=>{
                    if(this.info.content && this.info.content.indexOf(item) != -1){
                        words.push(item)
                    }
                })
            }
            return words.length > 0 ? words.join(',') : null
        }
    },
    data() {
        return {
            isloading: false,
            info: {
                type_id: 1,
                title: "",
                content: "",
            },
            houseCardId: '',
            modelId: '',
            typeList: [{
                id: 1,
                name: "楼盘动态"
            }, {
                id: 2,
                name: "开盘信息"
            }, {
                id: 3,
                name: "交房信息"
            }, {
                id: 4,
                name: "证件信息"
            }],
            inputVisible: false,
            inputValue: "",
            isClear: false,
            modelRules: {
                title: [
                    { validator: validateEmpty, result: "动态标题", trigger: "blur" },
                    { min: 1, max: 32, message: "长度1到32个字符" },
                ],
                content: [
                    { validator: validateEmpty, result: "动态内容", trigger: "blur" },
                    { min: 1, max: 3000, message: "长度1到3000个字符" }
                ]
            },
            // 编辑器配置
            eidtorOptions: {
                pictureConfig: {
                    code: UPLOAD_CODE.news
                },
                videoConfig: {
                    code: UPLOAD_CODE.newsVideo
                },
                wordLimit: 3000,
                uploadType: 'common',
                config: {
                    items: ['source', '|', 'undo', 'redo', '|', 'justifyleft', 'justifycenter', 'justifyright', '|', 'forecolor', 'bold', 'selectall', 'removeformat', 'clearhtml', 'quickformat', '|', 'picture', 'link', 'unlink', 'video', 'table', 'fullscreen', 'addhouse', 'addIframe'],
                }
            },
            centerDialogVisible: false,
            editorHouse: null,
            showError: false,
            filterWords:{},
            findWords:{
                type_risk:[],
                type_common:[],
                type_high_risk:[],
                type_author:[]
            },
            arisenWords:[],
            wordsDialog:false,
        };
    },
    mounted() {
        const parse = this.$route.query;
        if (parse) {
            this.modelId = parse.id
            this.getTreadsDetail(parse)
            getFilterWords().then(res => {
                this.filterWords = res
            })
        }
    },
    methods: {
        showHouseAdd() { //打开插入楼盘弹窗
            this.showError = false
            this.centerDialogVisible = true
        },
        insertHouse(item) { //编辑器插入楼盘表单
            this.editorHouse = item
            this.showError = false
        },
        editorInsert() {
            if (this.editorHouse) {
                console.log(`<house class="houseUnit" data-houseid="${this.editorHouse.id}">${this.editorHouse.name}</house>`)
                this.$refs.ue.pushContent(`<house class="houseUnit" data-houseid="${this.editorHouse.id}">${this.editorHouse.name}</house>`);
                this.centerDialogVisible = false
                this.editorHouse = null
                this.$refs.recommandRef.clear()
            } else {
                this.showError = true
                return false
            }
        },
        hideDia() {
            this.centerDialogVisible = false
            this.editorHouse = null
            this.$refs.recommandRef.clear()
        },
        showInput() {
            this.inputVisible = true;
            this.$nextTick((_) => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        async getTreadsDetail(parse) {
            await getHouseTrendsDetail(parse.id, { house_id: parse.house_id }).then((data) => {
                this.info = data;
                this.$refs.ue.pushContent(data.content);
                this.houseCardId = data.rcid;
                this.$store.commit('permission/SET_SITEID', this.info.site_id)
            })
        },
        resetForm() {
            this.$refs.modelRules && this.$refs.modelRules.clearValidate();
        },
        toList() {
            this.$router.push("dynamicDrafts");
        },
        submitForm(formName, type) {
            this.info.content = this.$refs.ue.getContent().html;
            let validInfo = {...this.info}
            let _imgReg = /<img[^>]+>/g
            validInfo.content = validInfo.content.replace(_imgReg, '{@img}');
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    this.isloading = true
                    let query = this.info;
                    let isPass = this.validFilterWords(validInfo)
                    if(!isPass){
                        this.wordsDialog = true;
                        this.isloading = false
                    }else{
                        this.edit(this.modelId, query);
                    }
                } else {
                    return false;
                }
            });
        },
        edit(id, query) {
            editHouseTrends(id, query)
                .then((data) => {
                    this.$message({
                        message: "编辑成功",
                        type: "success",
                        duration: 3 * 1000,
                    });
                    this.toList();
                })
                .catch((err) => {
                    this.$message({
                        message: err.message || "编辑失败",
                        type: "error",
                        duration: 3 * 1000,
                    });
                });
        },
        // 继续保存
        async continueSave(){
            this.edit(this.modelId, this.info);
            this.wordsDialog = false
        },
        // 暂不保存
        cancelSave(){
            this.arisenWords = [];
            if(this.findWords){
                for(let key in this.findWords){
                    if(this.findWords[key] && this.findWords[key].length>0){
                        this.arisenWords.push(...this.findWords[key])
                    }
                }
            }
            this.wordsDialog = false
        },
        validFilterWords(info){
            this.findWords = {
                type_risk:[],
                type_common:[],
                type_high_risk:[],
                type_author:[]
            },
            // 风险违禁词
            this.filterWords.type_risk.forEach((item,index) => {
                if(info.title.indexOf(item) != -1){
                    this.findWords.type_risk.push(item)
                }else if(info.content.indexOf(item) != -1){
                    this.findWords.type_risk.push(item)
                }
                this.findWords.type_risk = Array.from(new Set(this.findWords.type_risk))
            });
            // 通用违禁词
            this.filterWords.type_common.forEach((item,index) => {
                if(info.title.indexOf(item) != -1){
                    this.findWords.type_common.push(item)
                }else if(info.content.indexOf(item) != -1){
                    this.findWords.type_common.push(item)
                }
                this.findWords.type_common = Array.from(new Set(this.findWords.type_common))

            });
            // 高危违禁词
            this.filterWords.type_high_risk.forEach((item,index) => {
                if(info.title.indexOf(item) != -1){
                    this.findWords.type_high_risk.push(item)
                }else if(info.content.indexOf(item) != -1){
                    this.findWords.type_high_risk.push(item)
                }
                this.findWords.type_high_risk = Array.from(new Set(this.findWords.type_high_risk))

            });
            if(this.findWords.type_risk.length > 0 || this.findWords.type_common.length > 0 || this.findWords.type_high_risk.length > 0){
                return false
            }else{
                return true
            }
        },
    },
};
</script>
<style scoped lang="less">
.hosueDia span.label {
    float: left;
    display: inline-block;
    font-size: 16px;
    line-height: 40px;
    margin-right: 10px;
}

.hosueDia .el-autocomplete {
    width: 80% !important;
    float: left;
}

.hosueDia .house-ipt {
    width: 100%;
    height: 40px;
}

.hosueDia .error-tip {
    margin-top: 10px;
    padding-left: 100px;
    color: red;
}

.form-group-style .form-input-item .el-tag /deep/ .el-icon-close {
    display: inline-block !important;
    border-radius: 50%;
    text-align: center;
    position: relative !important;
    cursor: pointer;
    font-size: 12px !important;
    height: 16px !important;
    width: 16px !important;
    line-height: 16px !important;
    vertical-align: middle;
    top: -1px !important;
    right: -5px !important;
}

.form-group-style .form-container .form-item .form-label {
    width: 20%;
}

.form-group-style .form-container .form-input-item {
    width: 40%;
}

.form-group-style {
    min-height: 600px;
    background-color: #fff;
}

.bidding-tips .form-input-item {
    width: 50% !important;
}

.huxing-input {
    display: -webkit-box;
    height: 152px;

    .el-form-item {
        -webkit-box-flex: 1;
    }

    .labels {
        font-size: 13px;
        color: #666;
        padding: 0 8px;
        display: block;
    }

    .flex-all {
        -webkit-box-flex: 1;
    }
}

.checked-labels {
    border: 1px solid #e4e7ed;
    font-size: 13px;
    color: #666;
    padding: 0px 16px;
    border-radius: 3px;
    margin: 0 15px 15px 0;
    display: inline-block;
    position: relative;
    cursor: pointer;

    .shadow {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        cursor: pointer;
        transition: all 0.1s linear;
        opacity: 0;

        .el-icon-delete {
            color: #fff;
            font-size: 18px;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            width: 15px;
            height: 20px;
            display: block;
        }
    }

    &:hover {
        .shadow {
            opacity: 1;
        }
    }
}

p.tip {
    color: #666;
    margin-left: 20px;
}

.el-tag+.el-tag {
    margin-left: 10px;
}

.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}

.input-new-tag {
    width: auto;
    margin-left: 10px;
    vertical-align: bottom;
}

.red {
    color: red;
}

.add-btn {
    margin-left: 10px;
}
.word_error{
    position: relative;
    top:-10px;
    color:red;
}
</style>